
import React, { useState } from "react";
import { Form, Col, Modal } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { useDispatch } from "react-redux";
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";
import * as handlers from "../../../../_redux/settings/settingsHandlers";

const NewWebhook = ({show, onHide}) => {

  const dispatch = useDispatch();
  const [validated, setValidated] = useState(false);

  const handleSubmit = e =>  {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;

    if (form.checkValidity() === true) {
      const formData = new FormData(form);
      onHide();
      dispatch(handlers.addWebhook(Object.fromEntries(formData.entries())));
    }
    setValidated(true);
  }
    
  return (
    <Modal
        show={show}
        onHide={onHide}
        aria-labelledby="contained-modal-title-vcenter"
        onExited={_ => setValidated(false)}
      >
      <Form
        noValidate
        validated={validated}
        onSubmit={handleSubmit}
      >
        <Modal.Header >
          <Modal.Title id="contained-modal-title-vcenter">
            <span className="svg-icon svg-icon-lg svg-icon-primary mr-3">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Code/Github.svg")}/>
            </span>
            Create New Webhook
          </Modal.Title>
          <button type="button" className="close" onClick={onHide}>
              <span aria-hidden="true" className="d-block">×</span>
              <span className="sr-only">Close</span>
           </button>
        </Modal.Header>
        <Modal.Body className="px-10">
            <input type="hidden" name="secretHash" value="SecretHash"/>
            <Form.Row>
              <Form.Group as={Col} md="12" controlId="firstName">
                <Form.Label >Url</Form.Label>
                <Form.Control
                  required
                  type="url"
                  name="url"
                  pattern="(http[s]?:\/\/)(www.)?([-a-zA-Z0-9_]{2,256}\.[-a-zA-Z0-9_]{2,256}\b(\/?[-a-zA-Z0-9@:%_\+.~#?&\/=]+)?)"
                />
                <Form.Control.Feedback  type="invalid">Please provide a valid Url</Form.Control.Feedback>
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col} md="12" controlId="adminLevel">
              <Form.Label >Retry</Form.Label>
                <Form.Control
                    required
                    as="select"
                    className="mr-sm-2"
                    custom
                    name="retryStatus"
                >
                    <option value="ENABLED">Enable</option>
                    <option value="DISABLED">Disable</option>
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  Select Retry Status
                </Form.Control.Feedback>


              </Form.Group>
            </Form.Row>
        </Modal.Body>
        <Modal.Footer>
            <button
                type="button"
                onClick={onHide}
                className="btn btn-light btn-elevate px-4"
            >
                Cancel
            </button>
            <> </>
            <button
                type="submit"
                className="btn btn-primary btn-elevate px-4 ml-4"
            >
                Create
            </button>
        </Modal.Footer>
          </Form>
      </Modal>

        );
}

export default NewWebhook;